/**
 * Money is stored as integer micros: 1 unit of currency = 1,000,000 micros.
 * Provider rates are fractions of a cent (a TTS character, an LLM token), so
 * cents would round most of a call's cost away; micros keep it exact in an
 * integer and still sum safely far past any realistic bill.
 */
export const MICROS = 1_000_000;
export const toMicros = (amount) => Math.round(amount * MICROS);
export const fromMicros = (micros) => micros / MICROS;
/** Cost of `quantity` units at `perUnitMicros`, rounded to a whole micro. */
export const lineMicros = (quantity, perUnitMicros) => Math.round(quantity * perUnitMicros);
export function formatMoney(micros, currency = 'USD', options = {}) {
    const value = fromMicros(micros);
    const abs = Math.abs(value);
    // Sub-cent amounts are the norm per call; show enough digits to see them.
    const digits = options.precise ? (abs > 0 && abs < 0.01 ? 5 : abs < 1 ? 4 : 2) : 2;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    }).format(value);
}
//# sourceMappingURL=money.js.map